import React from 'react';
import './TermeniSiConditii.css';

const sections = [
    {
        title: 'Ce este site-ul',
        text: 'Site-ul este administrat de SC EVOO MEDICAL SRL, cu datele din pagina „Date de identificare”. Prezintă clinica, specialitățile, medicii, prețurile și vă permite să cereți o programare sau să vă creați un cont.'
    },
    {
        title: 'Informațiile medicale de pe site',
        text: 'Articolele și descrierile au rol informativ. Nu înlocuiesc consultația și nu stabilesc un diagnostic. Pentru o urgență medicală sunați la 112.'
    },
    {
        title: 'Contul de pacient',
        items: [
            'Contul este personal. Păstrați parola doar pentru dumneavoastră și anunțați-ne dacă bănuiți că a ajuns la altcineva.',
            'Datele din cont trebuie să fie reale și actuale, pentru că după ele vă identificăm la recepție.',
            'Pentru un copil, contul îl creează și îl folosește părintele sau reprezentantul legal.',
            'Puteți închide contul oricând, din setări sau printr-un e-mail la contact@evoomedical.ro. Documentele medicale se păstrează însă pe durata cerută de lege, independent de cont.'
        ]
    },
    {
        title: 'Programările online',
        text: 'O cerere de programare devine programare după ce o confirmăm, prin telefon, SMS sau e-mail. Regulile de anulare, întârziere și plată sunt cele din „Condițiile generale de prestare a serviciilor medicale”, publicate pe site.'
    },
    {
        title: 'Prețurile',
        text: 'Prețurile publicate sunt cele în vigoare la data afișării și includ tot ce este descris la fiecare serviciu. Prețul final al unei proceduri se comunică în scris înainte de efectuarea ei. Serviciile medicale sunt scutite de TVA.'
    },
    {
        title: 'Drepturile asupra conținutului',
        text: 'Textele, fotografiile, sigla și grafica aparțin clinicii sau sunt folosite cu acordul autorilor. Le puteți cita cu indicarea sursei; nu le puteți reproduce în scop comercial fără acordul nostru scris.'
    },
    {
        title: 'Răspunderea',
        text: 'Facem tot ce ne stă în putere ca site-ul să funcționeze și informațiile să fie corecte. Nu răspundem pentru întreruperi tehnice independente de noi și nici pentru conținutul site-urilor externe la care trimit legăturile.'
    },
    {
        title: 'Datele personale și cookie-urile',
        text: 'Sunt explicate în „Politica de confidențialitate” și în „Politica de cookie-uri”.'
    },
    {
        title: 'Litigii',
        text: 'Orice nemulțumire o puteți trimite la contact@evoomedical.ro; răspundem în cel mult 30 de zile. Dacă nu ajungem la o soluție, vă puteți adresa ANPC, procedurilor de soluționare alternativă a litigiilor (pagina „Protecția consumatorilor”) sau instanțelor din România. Se aplică legea română.'
    },
    {
        title: 'Modificări',
        text: 'Când schimbăm acești termeni, publicăm noua versiune cu data ei. Pentru programările deja confirmate rămân valabile condițiile de la data confirmării.'
    }
];

function TermeniSiConditii() {
    return (
        <div className="terms-page">
            <header className="terms-hero">
                <span className="terms-eyebrow">Informații legale</span>
                <h1>Termeni și condiții de utilizare a site-ului</h1>
                <p className="terms-intro">
                    Folosind site-ul www.evoomedical.ro acceptați regulile de mai jos. Sunt puține și le-am scris cât am putut de simplu.
                </p>
            </header>

            <main className="terms-content">
                {sections.map((section, index) => (
                    <section className="terms-card" key={section.title}>
                        <div className="terms-number">{index + 1}</div>
                        <div>
                            <h2>{section.title}</h2>
                            {section.items ? (
                                <ul>
                                    {section.items.map((item) => (
                                        <li key={item}>{item}</li>
                                    ))}
                                </ul>
                            ) : (
                                <p>{section.text}</p>
                            )}
                        </div>
                    </section>
                ))}
            </main>

            <footer className="terms-footer">
                <p>EVOO-COM-MAN-01-R3 · versiunea din 25.10.2026</p>
            </footer>
        </div>
    );
}

export default TermeniSiConditii;
